module.exports = __webpack_public_path__ + "img/bsignup-continue-2@2x.69a474dd.png";